import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sid) { navigate("/login", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        applyAuth(data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
      } catch (e) {
        navigate("/login?error=google", { replace: true });
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <div className="h-9 w-9 bg-primary flex items-center justify-center animate-pulse">
        <ShieldCheck className="h-5 w-5 text-white" />
      </div>
      <span className="font-mono text-xs text-muted-foreground tracking-widest">SIGNING YOU IN…</span>
    </div>
  );
}
